export const URL = "https://api.flexip.com.br/api";
//export const URL = "http://localhost:8000/api";

export const API_GUARD = "admin";
